
import {Button} from "./button";
import Stream from "./frp/stream";
import { fieldName } from "./utils";
import { Image } from "utils";
import SETTINGS from "settings"
import { TYPE } from 'network/network_api'
import helpConfig from 'cfg/help-config';
import { literal_price, progressive_jackpot_panel, desc_to_stream, makeFrame, makeButton } from 'ui_commons'

export default function( { uiConfig, parent, always_interactive_container, spec } )
{
    const space = parent.child( "ui" );

    //all user input in current approach must be ignored by all subsequent receivers when consumed once:
    const $keyboard = parent.s( "keyboard" )
        .with( parent.s( "is_progressive_jackpot" ), ( event, pj ) => ({ event, pj }) )
        .filter( ({ pj }) => ! pj )
        .map( ({ event }) => ({ event, consumed : false }) )
    const $barrelClick = space.s( "barrelClick" ).map( () => ({ consumed : false }) );

    const $isRoulette = space.s( "isRoulette" );
    const $notRoulette = $isRoulette.map( r => ! r );

    const $notRisk = space.s( "isRisk" ).map( i => ! i );
    const $notFreegames = space.s( "isFreegames" ).map( f => ! f );
    const $isHelp = space.s( "isHelp" );
    const $notHelp = $isHelp.map( h => ! h );
    const $helpNotPaging = space.s( "helpPaging" ).map( p => ! p );
    const $notJackpot = space.s( "isJackpot" ).map( j => ! j );
    const $notBonus = space.s( "isBonus" ).map( b => ! b );
    const $not_error = parent.s( "isError" ).map( ie => ! ie )

    const panel_looks_like_enabled = space.s( 'panel_always_enabled', true )

    const $gambleVisible = Stream.any(
        space.s( "riskInvitation" ),
        $notHelp,
        $notBonus
    )
    .map( merge => _.every( merge ) && spec.risks.length > 0 )

    const $canSpin = space.s( "enabled" )
        .combineLatest( space.s( "canBet" ), space.s( "canPay" ), $notFreegames )
        .map( merge => _.every( merge ) );

    const container = new PIXI.Container;
    $isRoulette.subscribe( isRoulette => container.visible = ! isRoulette );

    if (!!uiConfig.main_panel) {
        const main_panel = Image( uiConfig.main_panel.frame );
        main_panel.position.set(uiConfig.main_panel.position.x, uiConfig.main_panel.position.y);
        container.addChild(main_panel);

        $notHelp
            .any($notRisk, $notJackpot, $notBonus, (nh, nr, nj, nb) => nh && nr && nj && nb)
            .name( space, 'main_panel_visibility' )
            .on( v => main_panel.visible = v )
    }

    const needProgJP = !!uiConfig.progressive_jackpot_panel;

    if (needProgJP) {
        progressive_jackpot_panel(
            parent,
            container,
            uiConfig.progressive_jackpot_panel,
            Stream.any( $notHelp, $notJackpot, $notFreegames, $notRisk, $notBonus )
                .map( merge => _.every( merge ) )
        )
    }



    /* _    ____ ___  ____ _    ____
       |    |__| |__] |___ |    [__
       |___ |  | |__] |___ |___ ___]
    */

    const { frames } = uiConfig;
    const createdLabels = []
    function l( desc, to, v, $text_v )
    {
        if ( ! frames || !frames[ desc ]) return;

        createdLabels.push( desc )
        const spec = frames[ desc ]
        const label = makeFrame( spec, uiConfig.common.font );
        container.addChild( label.frame );
        if ( to ) to.subscribe( p => {
            if( p === undefined ) p = "";
            label.label.text = p;
        } );

        if ( $text_v ) $text_v.on( text_v => label.label.visible = text_v )
        let $v;
        if ( v ) $v = v.length ? Stream.combineLatest( ... v ).map( merge => _.every( merge ) ) : v.map( _ => _ )
        if ( $v ) $v
            .name( space, "label_" + desc )
            .on( visible => label.frame.visible = visible );

        label.frame.position = spec.position
        space.s( 'label_' + desc + '_position' ).on( p => label.frame.position = p || label.frame.position )
    }

    l( 'lines',     space.s( "linesValue" ),      [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( 'line_bet',  space.s( "multiplierValue" ), [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( 'win',       space.s( "win" ),             [ $notRisk, $notHelp, $notJackpot, $notBonus ], space.s( "win" ).with( $not_error, ( v, ne ) => v > 0 && ne ) );
    l( 'credits_risk',   space.s( "credits" ),         space.s('isRisk') );
    l( 'credits',   space.s( "credits" ),         [ $notRisk, $notHelp, $notJackpot, $notBonus ] );
    l( 'total_bet', space.s( "price" ),           [ $notRisk, $notHelp, $notJackpot, $notBonus ] );

    //creating any other labels present in configuration:
    for ( const desc in frames )
    {
        if ( createdLabels.indexOf( desc ) >= 0 ) continue
        const spec = frames[ desc ]
        l(
            desc,
            spec.$value ? parent.s( spec.$value ) : undefined,
            spec.$visible ? parent.s( spec.$visible ) : undefined,
        )
    }

    /* ___  _  _ ___ ___ ____ _  _ ____
       |__] |  |  |   |  |  | |\ | [__
       |__] |__|  |   |  |__| | \| ___]
    */


    const { buttons } = uiConfig;
    const createdButtons = []
    /**
     * @param e stream or array of streams if button is ENABLED. Keyboard events of keys will be filtered out when button is NOT enabled.
     * @param v stream or array of streams if button is VISIBLE. Keyboard events of keys will be filtered out when button is NOT visible.
     * @param equiv What additional input may be interpreted the same as button click (when button can be clicked). Must be a stream of objects with "consumed" property originally equalling false.
     */
    function b(
        desc,
        to,
        keys,
        { e, v, equiv, look_like_enabled } = {},
        overriddenContainer
    )
    {
        if ( ! buttons || !buttons[ desc ]) return;

        createdButtons.push( desc )
        const button = makeButton( buttons[ desc ] );
        ( overriddenContainer || container ).addChild( button );

        const $e = desc_to_stream( space, e, "button_" + desc + "_enabled" )
        
        if ( look_like_enabled ) {
            $e.any( look_like_enabled, ( e, l ) => ({e, l}) )
                .on( ({e, l}) => {
                    button.enabled = e || l
                    button.interactive = e
                } )
        }
        else {
            $e.on(e => button.enabled = e);
        }

        const $v = desc_to_stream( space, v, "button_" + desc + "_visible" )
        $v.on( visible => button.visible = visible )

        const $click = space.s( "button_" + desc + "_click" )
        button.callback = () => {
            //if not just looks like enabled:
            if ( ! $e.value ) return
            $click.next()
        }
        if ( desc != "autoplay" && desc != "stop" && desc != 'collect' ) $click.to( space.s( "autoplayOff" ) )
        if ( keys || equiv )
        {
            let $input = $keyboard.filter( ({ event }) => _.includes( keys || [], event ) );
            $input = $input.name( space, "button_" + desc + "_equiv" )
            if ( equiv ) equiv.to( $input );

            if ( $e ) $input = $input.with( $e, ( state, e ) => ({ state, e }) ).filter( ({ e }) => e ).map( ({ state }) => state );
            if ( $v ) $input = $input.with( $v, ( state, v ) => ({ state, v }) ).filter( ({ v }) => v ).map( ({ state }) => state );

            //all user input in current approach must be ignored by all subsequent receivers when consumed once:
            $input
                .filter( state => ! state || ! state.consumed )
                .map( state => { if ( state ) state.consumed = true; return undefined; } )
                .to( $click )
        }
        if ( to ) $click.to( to )

        button.position = buttons[ desc ].position
        space.s( 'button_' + desc + '_position' ).on( p => button.position = p || buttons[ desc ].position )
    }

    // KEY CODES:
    const ENTER = 13;
    const ESC   = 27;
    const SPACE = 32;
    const KEY_1 = 49;
    const F1    = 112;
    const F2    = 113;
    const F3    = 114;
    const F4    = 115;
    const F5    = 116;
    const F6    = 117;
    const F7    = 118;
    const F8    = 119;
    const F9    = 120;
    const F10   = 121;

    b( "spin",             space.s( "spin" ),               [ ENTER, SPACE, F8 ], {
        e : $canSpin,
        v : [
            space.s( "spinVisible" ),
            $notRisk,
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "collect",          space.s( "collect" ),            [ ENTER, SPACE, F8 ], {
        e : space.s( "collectEnabled" ),
        v : [
            space.s( "collectVisible" ),
            space.s( "finishVisible" ).map( f => ! f ),
            $notHelp,
        ],
        equiv : $barrelClick
    } );
    b( "stop",             space.s( "stop" ),               [ ENTER, SPACE, F8 ], {
        e : space.s( "canInterruptBarrel" ),
        v : [
            space.s( "mayStop" ),
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "start",            space.s( "start" ),              [ ENTER, SPACE, F8 ], {
        e : [
            space.s( "displayingWin" ).map( d => ! d ),
            space.s( "beginningFeature" ).map( b => ! b )
        ],
        v : [
            space.s( "canStartFeature" ),
            $notHelp,
            $notBonus
        ],
        equiv : $barrelClick
    } );
    b( "finish",           space.s( "finish" ),             [ ENTER, SPACE, F8 ], {
        e : [
            space.s( "enabled" ),
            space.s( "finishEnabled" ),
        ],
        v : [
            space.s( "finishVisible" ),
            $notHelp,
        ],
        equiv : $barrelClick
    } );
    b( "info",             space.s( "info" ),               [ KEY_1, F1 ],        {
        e : space.s( "canBet" )
            .any(space.s( "collectEnabled" ), (canBet, collect) => canBet || collect),
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled
    } );

    const $muteSound = parent.s("muteSound").desc( 'mute sound by player' );

    b( "sound_on",             space.s( "sound_on" ),               [ ],        {
        e : $muteSound,
        v : $muteSound
    } );
    b( "sound_off",             space.s( "sound_off" ),               [ ],        {
        e : $muteSound.map(m => !m),
        v : $muteSound.map(m => !m)
    } );
    space.s("button_sound_on_click").map(() => false).to($muteSound);
    space.s("button_sound_off_click").map(() => true).to($muteSound);
    $muteSound
        .any( parent.s( 'tab_visibility' ), ( mute, tv ) => ({ mute, tv }) )
        .on( ({ mute, tv }) => {
            mute = mute || ( ! tv )
            Howler.mute( mute )
            if ( ! mute ) Howler.volume( SETTINGS.volume )
        } )

    b( "gamble",           space.s( "gamble" ),             [ F7 ],               {
        e : [
            space.s( "enabled" ),
            space.s( "finishVisible" ).map( v => ! v ),
            parent.s( 'state' ).map( s => s.state.risk_possible ),
        ],
        v : $gambleVisible
    } );
    b( "betmax",           space.s( "maxBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
            space.s( "canMaxBet" ),
        ],
        v : [
            space.s( "canMaxBet" ).combineLatest( space.s( "canMinBet" ), ( max, min ) => max || ! min ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "betmin",           space.s( "minBet" ),             undefined,            {
        e : [
            space.s( "enabled" ),
            space.s( "canBet" ),
        ],
        v : [
            space.s( "canMinBet" ),
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "autoplay",         space.s( "autoplayOn" ),         [ F9 ],               {
        //не засеряем интерфейс на время кручения барабана:
        e : [
            $gambleVisible.map( gv => ! gv ),
            $notFreegames
        ],
        v : [
            $gambleVisible.map( gv => ! gv ),
            $notRisk,
            $notHelp,
            $notBonus,
            $notJackpot,
            space.s( "isAutoplay" ).map( a => ! a )
        ]
    } );
    b( "autoplayoff",      space.s( "autoplayOff" ),        [ F9 ],              {
        //should always be able to cancel autoplay:
        //e : space.s( "enabled" ),
        v : [
            space.s( "isAutoplay" ),
            $gambleVisible.map( g => ! g ),
            $notHelp,
            $notJackpot,
            $notBonus
        ]
    } );
    b( "menu",             parent.s( "goLobby" ),           [ ESC ],              {
        //не засеряем интерфейс на время кручения барабана:
        /*e : space.s( "enabled" )
                .combineLatest(
                    space.s( "canBet" ),
                    parent.s( "isError" ),
                    ( e, c, i ) => ( e && c ) || i
                ),*/
        v : SETTINGS.nolobby ? false : $notHelp.any(
                $notJackpot,
                $notBonus,
                parent.s( "isError" ),
                $notRoulette,
                ( nh, nj, nb, e, nr ) => ( nh && nj && nb && nr ) || e
            )
    },
        always_interactive_container
    );
    b( "lines",            space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeLines" ), (like, can) => like && can)
    } );
    b( "decrease_lines",   space.s( "decreaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeLines" ), (like, can) => like && can)
    } );
    b( "increase_lines",   space.s( "increaseLines" ),      undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeLines" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeLines" ), (like, can) => like && can)
    } );
    b( "linebet",          space.s( "increaseMultiplier" ), [ F7 ],               {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeMultiplier" ), (like, can) => like && can)
    } );
    b( "decrease_linebet", space.s( "decreaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeMultiplier" ), (like, can) => like && can)
    } );
    b( "increase_linebet", space.s( "increaseMultiplier" ), undefined,            {
        e : [
            space.s( "canBet" ),
            space.s( "canChangeMultiplier" ),
        ],
        v : [
            $notRisk,
            $notHelp,
            $notJackpot,
            $notBonus
        ],
        look_like_enabled : panel_looks_like_enabled.any(space.s( "canChangeMultiplier" ), (like, can) => like && can)
    } );

    //inside help(info) scene:
    b( "next",             space.s( "helpNext" ),           [ F4 ],               {
        e : [
            space.s( "helpCanNext" ),
            $helpNotPaging,
        ],
        v : $isHelp.map(h => h && (helpConfig.help.pages > 1)),
    } );
    b( "back",             space.s( "helpPrevious" ),       [ F2 ],               {
        e : [
            space.s( "helpCanPrevious" ),
            $helpNotPaging,
        ],
        v : $isHelp.map(h => h && (helpConfig.help.pages > 1)),
    } );
    b( "exit",             space.s( "helpExit" ),           [ F3 ],               {
        e : $helpNotPaging,
        v : $isHelp,
    } );

    //creating any other buttons present in configuration:
    for ( const desc in buttons )
    {
        if ( createdButtons.indexOf( desc ) >= 0 ) continue
        b( desc )
    }

    const k = key => $keyboard.filter( state => ! state.consumed && key.length ? _.includes( key, state.event ) : state.event == key );

    //set lines with keyboard:
    function setLines( key, lines )
    {
        k( key )
            .withLatestFrom(
                $notHelp,
                space.s( "canBet" ),
                parent.s( "isError" ),
                ( state, notHelp, canBet, isError ) => ({ state, can : notHelp && canBet && ! isError })
            )
            .filter( ({ can }) => can )
            .filter( ({ state }) => ! state.consumed )
            .do( ({ state }) => state.consumed = true )
            .map( () => lines )
            .subscribe( space.s( "setLines" ) );
    }
    switch ( spec.lines_array.length )
    {
        case 1:
            break
        case 5:
            setLines( F2, 0 );
            setLines( F3, 1 );
            setLines( F4, 2 );
            setLines( F5, 3 );
            setLines( F6, 4 );
            break
        default:
            console.error( "Undefined amount of lines groups." )
    }

    const $startImpulse = space.s( "startImpulse" );
    k( [ ENTER, SPACE, F8 ] ).subscribe( $startImpulse );
    $startImpulse
        .withLatestFrom(
            parent.s( "isError" ),
            parent.s( "animating" ),
            ( key, isError, animating ) => ({ isError, animating })
        )
        .filter( ({ isError, animating }) => ! isError && ! animating )
        .map( () => undefined )
        .subscribe( space.s( "startKey" ) );

    if (needProgJP && !uiConfig.no_currency) {
        currency(
            container,
            space.s("credits"),
            parent.s("balance"),
            parent.s("balance:money"),
            $notHelp.any($notJackpot, $notBonus, (nh, nj, nb) => nh && nj && nb),
        )
    }


    return {
        space,
        ui : container,
    };
}

function currency( container, $credits, $balance, $money, $visible )
{
    const view = new PIXI.Container;
    container.addChild( view );
    $visible.subscribe( v => view.visible = v );

    // left billet
    const currencyFrame = Image( 'currency_frame.png' )
    currencyFrame.visible = false;
    view.addChild( currencyFrame );

    currencyFrame.position.set(
        SETTINGS.screen.resolution.height == 600 ? 76 : 98,
        SETTINGS.screen.resolution.height == 600 ? 518 : 665
    )

    const currencyValueLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: SETTINGS.screen.resolution.height == 600 ? 10 : 12,
            fill: ['#ffffff']
        } )
    );
    currencyValueLabel.position.set(
        SETTINGS.screen.resolution.height == 600 ? 11 : 12,
        SETTINGS.screen.resolution.height == 600 ? 9 : 11
    )
    currencyFrame.addChild( currencyValueLabel );


    // right billet
    const creditPriceFrame = Image( 'currency_frame.png' )
    creditPriceFrame.visible = false;
    view.addChild( creditPriceFrame );
    creditPriceFrame.position.set(
        SETTINGS.screen.resolution.height == 600 ? 606 : 778,
        SETTINGS.screen.resolution.height == 600 ? 518 : 665
    )

    const creditPriceLabel = new PIXI.Text(
        '',
        new PIXI.TextStyle(
        {
            fontFamily: 'Arial',
            fontSize: SETTINGS.screen.resolution.height == 600 ? 10 : 12,
            fill: ['#ffffff']
        } )
    );
    creditPriceLabel.position.set(
        SETTINGS.screen.resolution.height == 600 ? 10 : 12,
        SETTINGS.screen.resolution.height == 600 ? 9 : 11
    )
    creditPriceFrame.addChild( creditPriceLabel );

    $balance
        .any( $credits, $money, ( balance, credits, money ) => ({ balance, credits, money }) )
        .subscribe( ({ balance, credits, money }) =>
        {
            let visible = true;
            if ( ! balance.currency || ! balance.credit_price ) visible = false;
            else if ( balance.currency.visible === false || balance.currency.visible === "false" ) visible = false;
            currencyFrame.visible = creditPriceFrame.visible = visible
            if ( ! visible ) return;

            currencyValueLabel.text = balance.currency.code_name + " " + literal_price( money, balance.currency.minor_unit, balance.currency.delimiter );

            creditPriceLabel.text = "1 credit = " + literal_price( balance.credit_price, balance.currency.minor_unit, balance.currency.delimiter ) + " " + balance.currency.code_name;
        } );
}





// WEBPACK FOOTER //
// ./src/library/ui_view.es6